@if (modules().length) {
  <pxc-form-grid-trigger
    placement="section"
    [moduleInputs]="moduleInputs()"
    [modules]="modules()"
    [targetId]="sectionId()"
    (moduleReset)="resetModule($event)"
    (moduleTriggered)="applyModule($event)" />
}
